import React from 'react';
import { Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import AdCard from './AdCard';
import './AdsSection.css';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const responsive = {
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 4,
        slidesToSlide: 4 // optional, default to 1.
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 3,
        slidesToSlide: 3 // optional, default to 1.
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1,
        slidesToSlide: 1 // optional, default to 1.
    }
};

const AdsSection = ({ title, items, buttonLink }) => (
    <Container fluid className="items-section-container">
        <Container>
            <div className="items-section">
                {/* Header Section */}
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h2 className="items-section-heading">{title}</h2>
                    {buttonLink && (
                        <Link to={buttonLink}>
                            <Button className="btn btn-danger view-all-items-btn">Poglej vse oglase</Button>
                        </Link>
                    )}
                </div>

                {/* Grid Section */}
                {/* Check if items array exists and has items before rendering Carousel */}
                {items && items.length > 0 ? (
                    <Carousel
                        responsive={responsive}
                        autoPlay={true} // Consider setting this based on props or state if needed
                        swipeable={true}
                        draggable={true}
                        showDots={true}
                        infinite={true}
                        partialVisible={false}
                        dotListClass="custom-dot-list-style"
                    >
                        {items.map(item => (
                            // Ensure each child in a list has a unique "key" prop - using item.id here
                            <div className="slider" key={item.id}>
                                {/* Removed Col as Carousel handles item layout */}
                                <AdCard
                                    id={item.id}
                                    images={item.images}
                                    category={item.category}
                                    title={item.title}
                                    location={item.location}
                                    price={item.price}
                                    created_at={item.created_at}
                                    isInsideCarousel={true}
                                />
                            </div>
                        ))}
                    </Carousel>
                ) : (
                    // Optional: Display a message if there are no items
                    <p>Trenutno ni oglasov za prikaz.</p>
                )}
            </div>
        </Container>
    </Container>
);

export default AdsSection;